import React, { useState, useContext } from "react";
import styled, { keyframes } from "styled-components";
import Banner from "../../images/main1_banner.png";

import GlobalFonts from "../../fonts/fonts";
import "../../fonts/font.css";

import { Link } from "react-router-dom";
import DaumPostCode from "react-daum-postcode";

import {
  CardWithInput,
} from "../cards/card_box";
import {
  StyledBox,
  CardTitle,
  CardText,
  InputDiv,
  SearchIcon,
  Radio,
  RadioLabel,
} from "../cards/card_componets";
import {
  DarkBackground,
} from "../main/dialog";
import { ButtonWithIcon, FeeButton } from "../button";
import Dialog from "./dialog";
import FeeDialog from "./fee_modal";


const Wrapper = styled.div`
  min-height: 100%;
  width: 100%;
`;

const PageContainer = styled.body`
  position: relative;

  width: 100vw;
  height: 100%;

  display: flex;
  flex-direction: column;

  align-items: center;
`;

const BannerImage = styled.img`
  position: relative;
  width: 1280px;
  height: 257px;

  margin-top: 30px;
`;
BannerImage.defaultProps = {
  src: Banner,
};

const BoxWrapper = styled.div`
  position: relative;
  display: flex;
  margin-top: 50px;
  margin-bottom: 70px;
`;

export default function Body() {
  let [parkSpaceNum, setParkSpaceNum] = useState("");
  // let [selectTime, setSelectTime] = useState("");
  // let [selectFee, setSelectFee] = useState("");
  let [radioValue, setRadioValue] = useState("");

  const [dialog, setDialog] = useState(false);
  const [feeDialog, setFeeDialog] = useState(false);
  const onClick = () => {
    setDialog(true);
  };
  const onFeeClick = () => {
    setFeeDialog(true);
  };
  const onClose = () => {
    setDialog(false);
    setFeeDialog(false);
  };
  const onMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(e);
    }
  };
  const onPostMaskClick = (e) => {
    if (e.target !== e.currentTarget) {
      onClose(e);
    }
  };

  //const { isPostShow, isPostClose } = this.props;
  let [isdaumpost, setDaumPost] = useState(false);
  let [isAddress, setIsAddress] = useState("주차장 주소 검색");
  let [bname, setbname] = useState("");
  let [sigungu, setSigungu] = useState("");

  const handleOpenPost = () => {
    setDaumPost((prev) => !prev);
  };
  const handleAddress = (data) => {
    let AllAddress = data.address;
    let placebname = data.bname;
    let placesigungu = data.sigungu;

    setIsAddress(AllAddress);
    setbname(placebname);
    setSigungu(placesigungu);
    setDaumPost(false);
  };
  const width = 500;
  const height = 450;
  const modalStyle = {
    animation: "true 1s 1s",
    position: "absolute",
    left: "50% - (500/2)px",
    top: "50% - (450/2)px",
    zIndex: "200",
    border: "1px solid #eeeeee",
    borderRadius: "15px",
    radius: "15px",
    overflow: "hidden",
  };

  // const handleSelectTime = (e) => {
  //   setSelectTime(e.target.value);
  // };

  // const handleSelectFee = (e) => {
  //   setSelectFee(e.target.value);
  // };

  var isFeecomplete = sessionStorage.getItem("submitComplete");

  const handleComplete = (e) => {
    if (
      parkSpaceNum !== "" &&
      isAddress !== "주차장 주소 검색" &&
      isFeecomplete !== false &&
      radioValue !== ""
    ) {
      sessionStorage.setItem("adress", isAddress);
      sessionStorage.setItem("spacenum", parkSpaceNum);
      //sessionStorage.setItem("fee", selectFee);
      //sessionStorage.setItem("time", selectTime);
      sessionStorage.setItem("radio", radioValue);
      sessionStorage.setItem("bname",bname);
      sessionStorage.setItem("sigungu", sigungu);
    } else {
      e.preventDefault();
      setDialog(true);
    }
  };

  return (
    <Wrapper>
      <GlobalFonts />
      <PageContainer>
        <BannerImage />
        <BoxWrapper>
          <StyledBox
            borderColor={
              isAddress !== "주차장 주소 검색" ? "#EF8A57" : null
            }
            borderSize={isAddress !== "주차장 주소 검색" ? "2" : "0.5"}
            boxShadow = {isAddress !== "주차장 주소 검색" ? "0px 0px 6px rgba(186, 93, 27, 0.32)" : null}
          >
            <CardTitle>🏡 주차장 주소</CardTitle>
            <CardText fontSize="17" lineHight="20">
              내 주차장의 주소를 검색하여 입력해주세요.
            </CardText>
            <InputDiv onClick={handleOpenPost}>
              {isdaumpost ? (
                <DarkBackground>
                  <DaumPostCode
                    onComplete={handleAddress}
                    onClose={onClose}
                    width={width}
                    height={height}
                    style={modalStyle}
                    isdaumpost={isdaumpost}
                    onPostMaskClick={onPostMaskClick}
                  ></DaumPostCode>
                </DarkBackground>
              ) : null}
              <SearchIcon />
              {isAddress}
            </InputDiv>
          </StyledBox>
          <CardWithInput
            onChange={(e) => {
              setParkSpaceNum(e.target.value);
            }}
            title="🚗 주차면수"
            text="아래 입력란에 주차면수를 입력해주세요."
            placeholder="주차면수 입력"
            color="#ffffff"
            borderColor={
              parkSpaceNum !== "" ? "#EF8A57" : null
            }
            borderSize={parkSpaceNum !== "" ? "2" : "0.5"}
            boxShadow = {parkSpaceNum !== "" ? "0px 0px 6px rgba(186, 93, 27, 0.32)" : null}
          ></CardWithInput>
          <StyledBox
            borderColor={
            sessionStorage.getItem("submitComplete") ? "#EF8A57" : null
            }
            borderSize={sessionStorage.getItem("submitComplete") ? "2" : "0.5"}
            boxShadow = {sessionStorage.getItem("submitComplete") ? "0px 0px 6px rgba(186, 93, 27, 0.32)" : null}>
            <CardTitle>💵 주차장 요금 </CardTitle>
            <CardText fontSize="17" lineHight="20">
              내 주차장의 주차 요금을 모두 입력해주세요.
            </CardText>
            {sessionStorage.getItem("submitComplete") ? (
              <FeeButton
                onFeeClick={onFeeClick}
                color="#EF8A57"
                text="요금제 입력 완료"
                height="50"
                width="230"
                marginBottom="30"
                fontWeight="bold"
              ></FeeButton>
            ) : (
              <FeeButton
                onFeeClick={onFeeClick}
                text="주차장 요금제 선택"
                height="50"
                width="230"
                marginBottom="30"
              ></FeeButton>
            )}
          </StyledBox>
          <StyledBox
          borderColor={
            radioValue !== "" ? "#EF8A57" : null
          }
          borderSize={radioValue !== "" ? "2" : "0.5"}
          boxShadow = {radioValue !== "" ? "0px 0px 6px rgba(186, 93, 27, 0.32)" : null}
          >
            <CardTitle> 🤝 관리 주체 </CardTitle>
            <CardText fontSize="16" lineHight="25" marginBottom="15">
              주차장 관리 주체를 선택해 주세요.
            </CardText>
            <div>
              <Radio
                type="radio"
                name="manage"
                id="1"
                value="self"
                onChange={(e) => {
                  setRadioValue(e.target.value);
                }}
              />
              <RadioLabel for="1">제가 직접 합니다.</RadioLabel>
            </div>
            <div>
              <Radio
                type="radio"
                name="manage"
                id="2"
                value="consignment"
                onChange={(e) => {
                  setRadioValue(e.target.value);
                }}
              />
              <RadioLabel for="2">위탁업체에 맡겨요.</RadioLabel>
            </div>
          </StyledBox>
        </BoxWrapper>
        <Link to="./resultPage" onClick={handleComplete}>
          <ButtonWithIcon
            text="나의 주차장 수익 알아보기"
            color={
              parkSpaceNum !== "" &&
              isAddress !== "주차장 주소 검색" &&
              isFeecomplete !== false &&
              radioValue !== ""
                ? "#EF8A57"
                : "#C7C7C7"
            }
            marginBottom="140"
          ></ButtonWithIcon>
        </Link>
      </PageContainer>
      <FeeDialog
        visible={feeDialog}
        onMaskClick={onMaskClick}
        onClose={onClose}
      />
      <Dialog onMaskClick={onMaskClick} onClose={onClose} visible={dialog} />
    </Wrapper>
  );
}

function Modal() {}

/*
      <Link to="./result">
      <ButtonWithIcon text="나의 주차장 수익 알아보기" onClick={onClick}></ButtonWithIcon>
      </Link>
*/
